import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  @Input() loading: boolean;
  @Input() withSpinner: boolean;
  @Input() withOverlay: boolean = true;
  @Input() diameter: number = 100;
  @Input() withBaseClass: boolean = false;
  @Input() withMinHeight: boolean = false;
  @Input() withoutMinHeightOnLoaded: boolean = false;

  radius: number;

  ngOnInit() {
    this.radius = -Math.round(this.diameter / 2);
  }
}
